import styled from "styled-components";
import { Row } from "react-bootstrap";

export const Styles = styled.div`
  .content {
    margin-bottom: 8rem;
  }
`;

export const MessageStyles = styled.div`
  --alpha-user: 0.5;
  --alpha: 0.2;

  padding: 0.5em;

  .parent-card {
    background-color: ${(props) =>
      props.isQuestion
        ? "#ffe880"
        : props.isUser
        ? "rgba(var(--primary-dark-rgb), 0.15)"
        : "rgba(var(--primary-light-rgb), 0.8)"};
    padding-bottom: 1em;
    border-radius: 0.5em;
    height: min-content;
    max-height: 6em;
    overflow: hidden;
    text-overflow: ellipsis;

    cursor: pointer;
  }

  .reply-button {
    position: absolute;
    right: 0.5em;
    top: 0.5em;
  }

  .reply-button,
  .reference-buttons {
    color: rgba(var(--primary-dark-rgb), 0.5);

    :hover {
      color: var(--primary-dark);
    }
  }

  .parent-text {
    transform: scale(0.9);
  }

  .card {
    border: none;
    background-color: rgba(
      var(--accent-primary-light-rgb),
      ${(props) => (props.isUser ? "var(--alpha-user)" : "var(--alpha)")}
    );

    ${(props) => (props.isQuestion ? "background-color: #ffe880;" : "")}

    border-radius: ${(props) => (props.isUser ? "1em 0.15em 1em 1em" : "0.15em 1em 1em 1em")};
  }

  .card-body {
    padding: 0.5em;
  }

  .card-title {
    color: var(--text-primary-light);
  }

  .card-text {
    color: ${(props) => (props.isUser ? "var(--on-accent-primary-light)" : "var(--text-primary-light)")};
  }

  .message-title {
    font-weight: light;
    padding: 0.2em 0.2em 0.2em 0.4em;
    color: var(--text-primary-light);
  }

  .message-time {
    color: var(--text-primary-light);
    font-weight: 400;
    margin: 0;
  }
`;

export const ReactionRow = styled(Row)`
  ${(props) => props.dark === true && "color: #fff"};

  .placeholder-reaction {
    opacity: 0.5;
  }

  :hover {
    .placeholder-reaction {
      display: none;
    }
  }
`;

export const ReactionStyles = styled.div`
  display: ${(props) => (props.visible ? "block" : "none")};

  ${ReactionRow}:hover & {
    display: block;
  }

  .fas {
    :hover {
      cursor: pointer;
      opacity: 1;
      transform: scale(1.2);

      transition: transform 0.2s ease-in-out;
    }

    opacity: ${(props) => (props.userReacted ? "1" : "0.5")};
  }
`;
